// Copyright 2021
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/service/v1/alert_manager.proto (package msh.service.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { SpeechTrait_SpeechTranscriptEvent } from "../../trait/speech/v1/speech_pb";
import { Language } from "../../common/v1/language_pb";
import { ContactTime, Page } from "../../common/v1/common_pb";
import { Alert, AlertFilter } from "../../resource/v1/alert_pb";
import { PresenceTrait_PresenceEvent_PresenceStatus } from "../../trait/activities/v1/presence_pb";

/**
 * The parameters to SendAlert
 *
 * @generated from message msh.service.v1.SendAlertRequest
 */
export const SendAlertRequest = proto3.makeMessageType(
  "msh.service.v1.SendAlertRequest",
  () => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.SendAlertResponse
 */
export const SendAlertResponse = proto3.makeMessageType(
  "msh.service.v1.SendAlertResponse",
  () => [
    { no: 1, name: "alert_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "alert_created", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * The parameters to SendAlert
 *
 * @generated from message msh.service.v1.CreateWanderingAlertRequest
 */
export const CreateWanderingAlertRequest = proto3.makeMessageType(
  "msh.service.v1.CreateWanderingAlertRequest",
  () => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.CreateWanderingAlertResponse
 */
export const CreateWanderingAlertResponse = proto3.makeMessageType(
  "msh.service.v1.CreateWanderingAlertResponse",
  () => [
    { no: 1, name: "alert_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "alert_created", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message msh.service.v1.ProcessAlertRequest
 */
export const ProcessAlertRequest = proto3.makeMessageType(
  "msh.service.v1.ProcessAlertRequest",
  () => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.ProcessAlertResponse
 */
export const ProcessAlertResponse = proto3.makeMessageType(
  "msh.service.v1.ProcessAlertResponse",
  () => [
    { no: 1, name: "alert_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "alert_created", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "confirmation_started", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message msh.service.v1.ConfirmAlertRequest
 */
export const ConfirmAlertRequest = proto3.makeMessageType(
  "msh.service.v1.ConfirmAlertRequest",
  () => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "transcript", kind: "message", T: SpeechTrait_SpeechTranscriptEvent },
  ],
);

/**
 * @generated from message msh.service.v1.ConfirmAlertResponse
 */
export const ConfirmAlertResponse = proto3.makeMessageType(
  "msh.service.v1.ConfirmAlertResponse",
  () => [
    { no: 1, name: "alert_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "alert_created", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "confirmation_started", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message msh.service.v1.AcknowledgeAlertRequest
 */
export const AcknowledgeAlertRequest = proto3.makeMessageType(
  "msh.service.v1.AcknowledgeAlertRequest",
  () => [
    { no: 1, name: "alert_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.AcknowledgeAlertResponse
 */
export const AcknowledgeAlertResponse = proto3.makeMessageType(
  "msh.service.v1.AcknowledgeAlertResponse",
  () => [
    { no: 1, name: "alert_ack_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "alert_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.AcknowledgeConsumerAlertRequest
 */
export const AcknowledgeConsumerAlertRequest = proto3.makeMessageType(
  "msh.service.v1.AcknowledgeConsumerAlertRequest",
  () => [
    { no: 2, name: "alert_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.AcknowledgeConsumerAlertResponse
 */
export const AcknowledgeConsumerAlertResponse = proto3.makeMessageType(
  "msh.service.v1.AcknowledgeConsumerAlertResponse",
  () => [
    { no: 1, name: "alert_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.IncreaseAlertLevelRequest
 */
export const IncreaseAlertLevelRequest = proto3.makeMessageType(
  "msh.service.v1.IncreaseAlertLevelRequest",
  () => [
    { no: 1, name: "alert_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "contact_info", kind: "message", T: IncreaseAlertLevelRequest_ContactInfo, repeated: true },
    { no: 3, name: "level", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message msh.service.v1.IncreaseAlertLevelRequest.ContactInfo
 */
export const IncreaseAlertLevelRequest_ContactInfo = proto3.makeMessageType(
  "msh.service.v1.IncreaseAlertLevelRequest.ContactInfo",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "level", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "lang", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 5, name: "contact_time", kind: "message", T: ContactTime, repeated: true },
  ],
  {localName: "IncreaseAlertLevelRequest_ContactInfo"},
);

/**
 * @generated from message msh.service.v1.IncreaseAlertLevelResponse
 */
export const IncreaseAlertLevelResponse = proto3.makeMessageType(
  "msh.service.v1.IncreaseAlertLevelResponse",
  [],
);

/**
 * @generated from message msh.service.v1.GetAlertsRequest
 */
export const GetAlertsRequest = proto3.makeMessageType(
  "msh.service.v1.GetAlertsRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "filter", kind: "message", T: AlertFilter },
    { no: 3, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetAlertsResponse
 */
export const GetAlertsResponse = proto3.makeMessageType(
  "msh.service.v1.GetAlertsResponse",
  () => [
    { no: 1, name: "alerts", kind: "message", T: Alert, repeated: true },
    { no: 2, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetAlertRequest
 */
export const GetAlertRequest = proto3.makeMessageType(
  "msh.service.v1.GetAlertRequest",
  () => [
    { no: 1, name: "alert_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.GetAlertResponse
 */
export const GetAlertResponse = proto3.makeMessageType(
  "msh.service.v1.GetAlertResponse",
  () => [
    { no: 1, name: "alert", kind: "message", T: Alert },
  ],
);

/**
 * @generated from message msh.service.v1.GetAlertByEventRequest
 */
export const GetAlertByEventRequest = proto3.makeMessageType(
  "msh.service.v1.GetAlertByEventRequest",
  () => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.GetAlertByEventResponse
 */
export const GetAlertByEventResponse = proto3.makeMessageType(
  "msh.service.v1.GetAlertByEventResponse",
  () => [
    { no: 1, name: "alert", kind: "message", T: Alert },
  ],
);

/**
 * @generated from message msh.service.v1.AcknowledgeAlertByUserRequest
 */
export const AcknowledgeAlertByUserRequest = proto3.makeMessageType(
  "msh.service.v1.AcknowledgeAlertByUserRequest",
  () => [
    { no: 1, name: "alert_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.AcknowledgeAlertByUserResponse
 */
export const AcknowledgeAlertByUserResponse = proto3.makeMessageType(
  "msh.service.v1.AcknowledgeAlertByUserResponse",
  () => [
    { no: 1, name: "alert_ack_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "alert_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.ProcessWanderingRequest
 */
export const ProcessWanderingRequest = proto3.makeMessageType(
  "msh.service.v1.ProcessWanderingRequest",
  () => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(PresenceTrait_PresenceEvent_PresenceStatus) },
    { no: 3, name: "previous_status", kind: "enum", T: proto3.getEnumType(PresenceTrait_PresenceEvent_PresenceStatus) },
  ],
);

/**
 * @generated from message msh.service.v1.ProcessWanderingResponse
 */
export const ProcessWanderingResponse = proto3.makeMessageType(
  "msh.service.v1.ProcessWanderingResponse",
  [],
);

